export const questions = [
  // Niveau 1
  { niveau: 1, question: "マイクミラーさん（　）かいしゃいんです。", choix: ["を", "は", "が", "に"], reponse: "は" },
{ niveau: 1, question: "（　）はわたしのかぞくのしゃしんです。", choix: ["これ", "ここ", "この", "こんな"], reponse: "これ" },
  { niveau: 1, question: "ぎんこうはごぜん9じからごご3じ（　）です。", choix: ["に", "へ", "まで", "で"], reponse: "まで" },
  { niveau: 1, question: "つくえのうえにほん（　）あります。", choix: ["が", "を", "に", "は"], reponse: "が" },
  // Niveau 2
  { niveau: 2, question: "りんごを３つ（　）かいました。", choix: ["に", "を", "ｘ", "が"], reponse: "ｘ" },
  { niveau: 2, question: "すみませんがしゃしんを（　）ください。", choix: ["とって", "とり", "とる", "とった"], reponse: "とって" },
  { niveau: 2, question: "ここでタバコを（　）いいですか。", choix: ["すう", "すっても", "すった", "する"], reponse: "すっても" },
  { niveau: 2, question: "あしたはにちようび（　）。だからがっこうへいかない。", choix: ["だ", "です", "な", "か"], reponse: "だ" },
  // Niveau 3
  { niveau: 3, question: "にほんはぶっかがたかい（　）おもいます。", choix: ["と", "を", "が", "だと"], reponse: "と" },
  { niveau: 3, question: "これはわたしがきのう（　）パンです。", choix: ["かった", "かう", "かって", "かうの"], reponse: "かった" },
  { niveau: 3, question: "ミラーさんはかんじを（　）ことができます。", choix: ["よみ", "よんで", "よんだ", "よむ"], reponse: "よむ" },
  { niveau: 3, question: "わたしはいちどもふじさんに（　）ことがありません。", choix: ["のぼる", "のぼって", "のぼった", "のぼり"], reponse: "のぼった" },    
  // Niveau 4   
  { niveau: 4, question: "つかれたから、ちょっと（　）。", choix: ["やすめた", "やすもう", "やすむな", "やすむと"], reponse: "やすもう" },
  { niveau: 4, question: "あめが（　）、ピクニックにいきません。", choix: ["ふる", "ふったら", "ふって", "ふれば"], reponse: "ふったら" },
  { niveau: 4, question: "せんせい、このかんじを（　）くださいませんか。", choix: ["かいて", "かき", "かく", "かいた"], reponse: "かいて" },
  { niveau: 4, question: "わたしは本を（　）のがすきです。", choix: ["よむ", "よみ", "よんで", "よんだ"], reponse: "よむ" }, 
  // Niveau 5
  { niveau: 5, question: "ニュースを（　）、びっくりしました。", choix: ["きいて", "きく", "きいた", "きけば"], reponse: "きいて" },
  { niveau: 5, question: "かいぎがなんじに（　）か、おしえてください。", choix: ["はじまる", "はじまります", "はじまった", "はじまり"], reponse: "はじまる" },
  { niveau: 5, question: "じぶんのみせを（　）ために、いっしょうけんめいはたらいています。", choix: ["もつ", "もって", "もった", "もたない"], reponse: "もつ" },
  { niveau: 5, question: "このはさみはかみを（　）のにつかいます。", choix: ["きる", "きって", "きった", "きり"], reponse: "きる" },    
]